import { FunctionComponent } from 'react';

import { Form } from '@kanda-libs/ks-component-ts';
import { Button, Loader, Price, Text } from '@kanda-libs/ks-design-library';

import { PaymentElement } from '@stripe/react-stripe-js';
import AcceptTermsInput from 'components/AcceptTermsInput';
import AlternatingText from 'components/AlternatingText';
import { formatToCurrency } from 'utils';

import useBacsPaymentFormElements from './useBacsPaymentFormElements';

import CardPaymentFormError from '../Error';
import CardPaymentFormLoader from '../Loader';

const BacsPaymentFormElements: FunctionComponent = () => {
  const {
    title,
    subheading,
    total,
    deposit,
    showHeading,
    form,
    onSubmit,
    isLoading,
    isSubmitting,
    showPropsError,
    disabled,
    amount,
    customHeading,
    onElementChange,
  } = useBacsPaymentFormElements();

  if (isLoading) return <CardPaymentFormLoader />;

  if (showPropsError) return <CardPaymentFormError />;

  return (
    <Form
      id="card-payment"
      form={form}
      onSubmit={onSubmit}
      className="flex flex-col"
    >
      {title && (
        <div className="mb-6">
          <Text className="text-20-24-em" text={title} />
        </div>
      )}
      {showHeading && (
        <div className="mb-6 md:mb-10">
          <div className="md:-mx-4 lg:-mx-12">
            <AlternatingText array={subheading} />
          </div>
          <div className="text-14-22-em grid grid-cols-2 mt-4 md:mt-6">
            <p>Total (incl. VAT)</p>
            <Price amount={total} className="ml-auto" color="neutral-700" />
            <p>Deposit</p>
            <Price amount={deposit} className="ml-auto" color="neutral-700" />
            <div className="border-b border-neutral-300 w-full col-span-2 my-1" />
            <p>Outstanding</p>
            <Price amount={amount} className="ml-auto" />
          </div>
        </div>
      )}
      {customHeading}

      <PaymentElement onChange={onElementChange} />

      <div className="mt-6 md:mt-8">
        <AcceptTermsInput />
      </div>

      <div className="flex flex-row justify-between mb-4 md:mb-6 text-16-20-em md:text-18-22-em">
        <span>Payment Amount:</span>
        <span className="text-neutral-800 text-18-22-em md:text-20-24-em">
          {formatToCurrency(amount)}
        </span>
      </div>

      <Button.Text
        submit
        disabled={disabled}
        id="open-banking-go-to-bank"
        label={
          <div className="flex flex-row">
            <span className="my-auto mr-2">Continue to bank</span>
          </div>
        }
        variant="gradient"
        icon="arrow-right"
        className="w-full"
      />
      <Loader isLoading={isSubmitting} />
    </Form>
  );
};

export default BacsPaymentFormElements;
